import { Helpers } from '../../helpers';
import { IConstraintFacilityExpansion } from '../../interfaces/iconstraint-facility-expansion';
import { AreaType } from '../area-type';
import { ConstraintFacilityExpansionDetail } from '../constraint-facility-expansion-detail';
import { Scenario } from '../scenario';

export class ConstraintFacilityExpansionBase {
  ConstraintFacilityExpansionId: number;
  ScenarioId: number;
  AreaTypeId: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ConstraintFacilityExpansionDetails_ConstraintFacilityExpansion?: Array<ConstraintFacilityExpansionDetail> | null;
  AreaType?: AreaType;
  Scenario?: Scenario;

  constructor(item?: IConstraintFacilityExpansion) {
    if (item) {

      this.ConstraintFacilityExpansionId = item.ConstraintFacilityExpansionId;
      this.ScenarioId = item.ScenarioId;
      this.AreaTypeId = item.AreaTypeId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ConstraintFacilityExpansionDetails_ConstraintFacilityExpansion = Helpers.createClassArray(ConstraintFacilityExpansionDetail, item.ConstraintFacilityExpansionDetails_ConstraintFacilityExpansion);
      this.AreaType = new AreaType(item.AreaType);
      this.Scenario = new Scenario(item.Scenario);
    }
  }
}